import Component from "./Component.js"

export default class BufferingOverlay extends Component {

  constructor(props, context) {
    super(props, context)
    this.classList.add("amp-buffering-overlay", true)
    this.classList.add("amp-icon")
  }

  static get contextTypes() {
    return super.contextTypes
  }
}
